
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st2",attrs:{"d":"M7.2 17.5c-2.2-.3-3.7-1.3-4.5-3.4h1.9C2.1 12.8.7 11 1 9.2c.6.2 1.2.4 1.8.5l.1-.1C.9 7.8.5 5.7 1.5 3.1c2.7 3.1 6 4.8 10.1 5.1 0-.7-.1-1.3 0-1.9.3-2.2 2.3-4 4.5-4.1 1.3-.1 2.5.3 3.5 1.2.3.3.6.3.9.2.6-.2 1.2-.4 1.7-.6.4 0 .6-.1.8-.2l.1.1c-.3.4-.5.9-.8 1.3-.3.4-.7.7-1 1.2.8-.2 1.5-.4 2.3-.6l.1.1c-.6.6-1.2 1.3-1.9 1.9-.3.2-.4.5-.4.8-.1 3.2-1 6.1-2.9 8.7-2.7 3.5-6.2 5.3-10.6 5.4-2.4.1-4.7-.5-6.9-1.6-.3-.1-.5-.3-.7-.5 2.5.1 4.7-.5 6.9-2.1"}})])
          )
        }
      }
    